import CadastroHeader from "../../components/CadastroHeader/CadastroHeader";
import ButtonPages from "../../components/ButtonPages/ButtonPages";
import styles from "../../styles/styles";
import "./Eventos.css";

import useEventosLog from "../../app/hooks/useEventosLog";
import { useEffect, useState } from "react";

import DatePicker, { registerLocale } from "react-datepicker";
import ptBR from "date-fns/locale/pt-BR";

import { Box, Paper } from "@mui/material";

import "react-datepicker/dist/react-datepicker.css";
import { usePermissao } from "../../app/hooks/UsePermissao";
import SemPermissao from "../../components/SemPermissao/SemPermissao";

registerLocale("pt-BR", ptBR);

export default function Eventos() {

  const { eventosLog, totalCount, todosUsuarios, listarEventosLog, buscarTodosUsuarios } = useEventosLog();

  const [filtroData, setFiltroData] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [filtroUsuario, setFiltroUsuario] = useState("");

  const [paginaAtual, setPaginaAtual] = useState(1);
  const [itensPorPagina] = useState(20);
  const { temPermissao } = usePermissao();

  useEffect(() => {
    if (!temPermissao("Usuario.VerLogs")) return;
    buscarTodosUsuarios();
  }, []);

  useEffect(() => {
    if (!temPermissao("Usuario.VerLogs")) return;
    listarEventosLog(paginaAtual, itensPorPagina, filtroData, filtroUsuario);
  }, [paginaAtual, filtroData, filtroUsuario]);

  useEffect(() => {
    if (paginaAtual !== 1) {
      setPaginaAtual(1);
    }
  }, [filtroData, filtroUsuario]);


  if (!temPermissao("Usuario.VerLogs")) {
    return (
      <Box sx={styles.pageWrapper}>
        <Box component="main" sx={styles.mainContent}>
          <Paper elevation={0} sx={styles.card}>
            <CadastroHeader
              title="Registro de eventos"
              subtitle="Visualize todos os eventos e ações realizadas no sistema"
            />
            <SemPermissao mensagem="Você não tem permissão para acessar estes dados." />
          </Paper>
        </Box>
      </Box>
    );
  }
  

  const handleDateChange = (date) => {
setSelectedDate(date);
    if (date) {

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      setFiltroData(`${year}-${month}-${day}`);

    } else {

      setFiltroData("");

    }

  };

  const formatarAcao = (acao) => {

    if (!acao) return acao;

    let textoFormatado = acao;

    textoFormatado = textoFormatado.replace(/alterado\./g, "alterado.\n");
    textoFormatado = textoFormatado.replace(/criado\./g, "criado.\n");
    textoFormatado = textoFormatado.replace(/excluído\./g, "excluído.\n");

    textoFormatado = textoFormatado.replace(/\s*Alterações:\s*/g, "\nAlterações:\n");

    textoFormatado = textoFormatado.replace(/([A-Z][a-z]+:.*?)\s*\|(?=\s*(Permissões|$))/g, "$1");

    textoFormatado = textoFormatado.replace(/\s*Permissões adicionadas:\s*/g, "\n\nPermissões adicionadas:\n");
    textoFormatado = textoFormatado.replace(/\s*Permissões removidas:\s*/g, "\n\nPermissões removidas:\n");

    textoFormatado = textoFormatado.replace(/\s+Nome:/g, "\n    - Nome:");

    textoFormatado = textoFormatado.replace(/\n    ([A-Z][a-z]+:)/g, "\n    - $1");

    textoFormatado = textoFormatado.replace(/\nAlterações:\s*\n+(?=Permissões|$)/g, "\n");

    return textoFormatado;

  };

  return (

    <Box sx={styles.pageWrapper}>


      <Box component="main" sx={styles.mainContent}>

        <Paper elevation={0} sx={styles.card}>


          <CadastroHeader
            title="Registro de eventos - Logs"
            subtitle="Visualize todos os eventos e ações realizadas no sistema"
          />

          <div className="eventos-content">

            <div className="filtros-wrapper">

              <div className="filtro-container">

                <label htmlFor="filtroData">
                  Filtrar por data:
                </label>

                <DatePicker
                  selected={selectedDate}
                  onChange={handleDateChange}
                  dateFormat="dd/MM/yyyy"
                  locale="pt-BR"
                  className="date-input-br"
                  placeholderText="DD/MM/AAAA"
                  isClearable
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />

              </div>

              <div className="filtro-container">

                <label htmlFor="filtroUsuario">
                  Filtrar por usuário:
                </label>

                <select
                  id="filtroUsuario"
                  value={filtroUsuario}
                  onChange={(e) => setFiltroUsuario(e.target.value)}
                >

                  <option value="">Todos</option>

                  {todosUsuarios.map((usuario) => (

                    <option key={usuario} value={usuario}>
                      {usuario}
                    </option>

                  ))}

                </select>

              </div>

            </div>

            <div className="linha-titulo linha-header">

              <p>Email</p>
              <p>Ação</p>
              <p>Data e Hora</p>

            </div>

            {eventosLog.length === 0 ? (

              <p>Não há eventos de log registrados.</p>

            ) : (

              eventosLog.map((evento) => (

                <div key={evento.id} className="linha-titulo linha-item">

                  <p>{evento.email}</p>
                  <p style={{ whiteSpace: 'pre-line' }}>
                    {formatarAcao(evento.acao)}
                  </p>        
                  <p>{evento.dataHora}</p>

                </div>

              ))

            )}

            <ButtonPages
              paginaAtual={paginaAtual}
              setPaginaAtual={setPaginaAtual}
              totalCount={totalCount}
              itensPorPagina={itensPorPagina}
            />

          </div>

        </Paper>

      </Box>

    </Box>

  );

}
